export default __webpack_public_path__ + "static/iphones-wealth-7eb1a242036c5333338ee9d82359c50e.png";